<div class="modal" tabindex="-1" role="dialog" id="toaster">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center">{{title}}</h5>
        </div>
        <div class="modal-body">
            <div *ngIf="isSuccess">
            <div class="circle">
                <div class="checkmark"></div>
              </div>
            </div>
            <div *ngIf="isError">
                <div class="exclamatiom-mark"></div>
            </div>
            <br>
            <p class="message">{{message}}</p>
            <br>
        </div>
        <button  type="button" class="btn btn-lg" data-dismiss="modal">Close</button>
        <!-- <button *ngIf="isAmend" type="button" class="btn btn-lg" data-dismiss="modal" [routerLink]="['/home']" >Close</button> -->
      </div>
    </div>
  </div>
  <button class="btn btn-success" aria-hidden="true" data-toggle="modal" data-target="#toaster" #trigger style="display: none;"></button>
  <button class="btn btn-success" aria-hidden="true" data-toggle="modal" data-target="#toaster" #toasterError style="display: none;"></button>

